import { useTranslation } from "react-i18next";
import { Alert } from "@h2j-data-team/ui";
import type { QvdAnalysisCoverage } from "@repo/shared";

// Alerts when the (opt-in) size phase could not measure wasted bytes: either a
// per-space access pre-flight failed (the connection identity can't read that
// space's DataFiles connection) or individual header reads failed. Without this
// the failure is invisible — the run just shows no wasted bytes.
export function QvdSizeCoverageBanner({ coverage }: { coverage: QvdAnalysisCoverage | null }) {
  const { t } = useTranslation("qvd-analysis");
  if (!coverage) return null;

  const deniedSpaces = coverage.sizeAccessDeniedSpaces ?? [];
  const failedCount = coverage.sizeFailedCount ?? 0;
  if (failedCount <= 0 && deniedSpaces.length === 0) return null;

  return (
    <Alert tone="warning">
      <div className="flex flex-col gap-1">
        <p>{t("sizeFailure.headline", { count: failedCount })}</p>
        {deniedSpaces.length > 0 && (
          <p className="text-xs">
            {t("sizeFailure.accessHint", { spaces: deniedSpaces.join(", ") })}
          </p>
        )}
      </div>
    </Alert>
  );
}
